import {NgModule} from '@angular/core';
import {ParallaxDirective} from './parallax';


@NgModule({
    declarations: [ParallaxDirective],
    exports: [ParallaxDirective]
})
export class ParallaxDirectiveModuleGeneric {}
